import React from "react";
import { useTranslation } from "react-i18next";
import { HeaderMainTitle } from "../Common/HeaderMainTitle";
import {
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { CareTeamMember } from "../CareTeam/CareTeamMember";
import { UserCircle } from "@phosphor-icons/react";

interface CareTeamMember {
  id: number;
  userId: string | null;
  teamId: number;
  teamName: string;
  roleId: number;
  roleName: string;
  email: string;
  createdAt: string;
  updatedAt: string | null;
  firstName: string | null;
  lastName: string | null;
  name: string | null;
  documentSigner: boolean | null;
  legalGuardian: boolean | null;
  hasAcceptedInvite: boolean;
  timezone?: string;
  familyId?: string;
  phone?: string;
  city?: string;
  state?: string;
  country?: string;
  zip?: string;
  address?: string;
  address2?: string;
  dateOfBirth?: string | null;
  gender?: string;
  relationship?: string | null;
  invitationGuid?: string;
  expirationDate?: string;
  imageUrl?: string;
  image_url?: string;
}

interface DrawerCareTeamProps {
  onBack: () => void;
  user: any;
  teamMembers: CareTeamMember[] | undefined;
  teamMembersLoading: boolean;
  customerDetails?: any;
}

export const DrawerCareTeam: React.FC<DrawerCareTeamProps> = ({
  onBack,
  user,
  teamMembers,
  teamMembersLoading,
  customerDetails,
}) => {
  const { t } = useTranslation(["clientHeader"]);
  const clientName = customerDetails?.name || t("clientHeader:menu.client");
  const title = t("clientHeader:careTeam.titleWithName", { name: clientName });

  const renderContent = () => {
    if (teamMembersLoading) {
      return (
        <Box
          sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 100 }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return teamMembers?.map((member) => <CareTeamMember member={member} key={member.id} />);
  };

  return (
    <>
      <HeaderMainTitle
        user={user}
        title={title}
        onBack={onBack}
        icon={UserCircle}
      />

      <Box sx={{ padding: "0 24px 24px 24px" }}>
        <Typography variant="body2" color="text.secondary">
          {t("clientHeader:careTeam.description", { name: clientName })}
        </Typography>

        {renderContent()}
      </Box>
    </>
  );
};
